// May this tab send Prestandavakten's measurement flags (`d` on the genomgång/game polls; `kg`,
// `ks`, `d` on the lesson bar's)? Only while the in-browser measurement is switched on
// (prestandaRumAndel > 0 on /admin/prestanda) — the same switch as RUM, because both read
// information on the student's device for the purpose of measuring the service, which the
// integritetspolicy (§14) must describe before it is switched on (lagen om elektronisk
// kommunikation 9 kap. 28 §; avtalsgranskning 2026-10-26). PrestandaRum, mounted by the root
// layout for students only, sets it. Browser only; off until set.

let tillaten = false;

export function sattKlientMatning(pa: boolean): void {
  tillaten = pa;
}

export function klientMatningTillaten(): boolean {
  return tillaten;
}
